var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBosniaAndHerzegovina(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#091c91",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6ce46",
    d: "M23 24 7 0h16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.71 5.38 1.38-1H7.4l-.53-1.63-.53 1.62h-1.7l1.38 1L5.48 7l1.38-1 1.38 1zM5.47 0l-.86.63.53 1.62-1.38-1-1.38 1L2.9.63 2.04 0zm5.34 10.13 1.38-1h-1.7L9.94 7.5l-.52 1.62h-1.7l1.38 1-.53 1.63 1.38-1 1.38 1zm3.09 4.75 1.38-1h-1.7l-.53-1.63-.53 1.62h-1.7l1.37 1-.52 1.63 1.38-1 1.38 1zm3.1 4.75 1.38-1h-1.71L16.14 17l-.53 1.62h-1.7l1.38 1-.53 1.63 1.38-1 1.38 1zM20.6 24l.87-.63h-1.7l-.54-1.62-.52 1.62H17l.86.63z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBosniaAndHerzegovina);
export default __webpack_public_path__ + "static/media/bosnia-and-herzegovina.c12be54440ed495df7a07c99d4f25473.svg";
export { ForwardRef as ReactComponent };